import {StyleSheet} from 'aphrodite';

import {GRAY} from 'ui-library/Colors';

const REQUEST_V2_SUBMISSION_DETAILS_STYLES = StyleSheet.create({
  wrapper: {
    border: `1px solid ${GRAY}`,
    borderRadius: `4px`,
    padding: '16px',
    marginTop: 16,
    marginBottom: 16,
    marginLeft: 8,
    marginRight: 8,
    width: '100%',
  },
  sectionHeader: {
    fontWeight: 600,
    fontSize: 16,
  },
});

export {REQUEST_V2_SUBMISSION_DETAILS_STYLES};
